import { BudgetTeamInCompanyInTokenDto } from '../../../common/pokCore/autogenerated/pokApiClient';

export const checkAccess = (
  bt: BudgetTeamInCompanyInTokenDto[],
  pokCompanyId: string,
) => {
  const listOfAccess = JSON.parse(
    process.env.REACT_APP_CONTRACT_ACCESS?.toLocaleLowerCase() || '{}',
  );
  if (!listOfAccess.length || listOfAccess.length === 0) {
    return true;
  }
  for (let i = 0; i < listOfAccess.length; i++) {
    const check = listOfAccess[i];
    const access = bt.find(
      o =>
        (!o.companyId ||
          o.companyId?.toLowerCase() === check.companyid?.toLowerCase()) &&
        (o.teamName === '' ||
          check.teamname === '' ||
          o.teamName?.toLowerCase() === check.teamname?.toLowerCase()) &&
        (o.budgetName === '' ||
          check.budgetsname === '' ||
          o.budgetName?.toLowerCase() === check.budgetsname?.toLowerCase()),
    );
    if (access && check.companyid === pokCompanyId) {
      return true;
    }
  }
  return false;
};
